module.exports = __webpack_public_path__ + "static/media/ic-select.a545fda6.svg";